import { createContext } from 'react';

export const ProductThemeContext = createContext<{ primaryShade: string; secondaryShade: string } | null>(null);
